import React, { useState, useEffect } from 'react';
import { trabajadorService, especialidadService } from '../services/api';
import '../styles/Trabajadores.css';

const Trabajadores = () => {
  const [trabajadores, setTrabajadores] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [trabajadorSeleccionado, setTrabajadorSeleccionado] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    especialidad_id: '',
    telefono: '',
    email: '',
    costo_hora: ''
  });

  useEffect(() => {
    cargarTrabajadores();
    cargarEspecialidades();
  }, []);

  const cargarTrabajadores = async () => {
    try {
      const response = await trabajadorService.getAll();
      setTrabajadores(response.data);
    } catch (error) {
      console.error('Error al cargar trabajadores:', error);
    } finally {
      setLoading(false);
    }
  };

  const cargarEspecialidades = async () => {
    try {
      const response = await especialidadService.getAll({ activo: 'true' });
      setEspecialidades(response.data);
    } catch (error) {
      console.error('Error al cargar especialidades:', error);
    }
  };

  const abrirModal = (trabajador = null) => {
    if (trabajador) {
      setTrabajadorSeleccionado(trabajador);
      setFormData({
        nombre: trabajador.nombre,
        especialidad_id: trabajador.especialidad_id || '',
        telefono: trabajador.telefono || '',
        email: trabajador.email || '',
        costo_hora: trabajador.costo_hora || ''
      });
    } else {
      setTrabajadorSeleccionado(null);
      setFormData({
        nombre: '',
        especialidad_id: '',
        telefono: '',
        email: '',
        costo_hora: ''
      });
    }
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setTrabajadorSeleccionado(null);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (trabajadorSeleccionado) {
        await trabajadorService.update(trabajadorSeleccionado.id, formData);
      } else {
        await trabajadorService.create(formData);
      }
      cargarTrabajadores();
      cerrarModal();
    } catch (error) {
      console.error('Error al guardar trabajador:', error);
      alert(error.response?.data?.error || 'Error al guardar trabajador');
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm('¿Estás seguro de eliminar este trabajador?')) return;

    try {
      await trabajadorService.delete(id);
      cargarTrabajadores();
    } catch (error) {
      console.error('Error al eliminar trabajador:', error);
      alert(error.response?.data?.error || 'Error al eliminar trabajador');
    }
  };

  const toggleActivo = async (trabajador) => {
    try {
      await trabajadorService.update(trabajador.id, {
        ...trabajador,
        activo: !trabajador.activo
      });
      cargarTrabajadores();
    } catch (error) {
      console.error('Error al actualizar trabajador:', error);
    }
  };

  if (loading) {
    return <div className="loading">Cargando trabajadores...</div>;
  }

  return (
    <div className="trabajadores-container">
      <div className="page-header">
        <h1>Trabajadores</h1>
        <button className="btn btn-primary" onClick={() => abrirModal()}>
          + Nuevo Trabajador
        </button>
      </div>

      {trabajadores.length === 0 ? (
        <div className="empty-state">
          <p>No hay trabajadores registrados</p>
          <button className="btn btn-primary" onClick={() => abrirModal()}>
            Agregar primer trabajador
          </button>
        </div>
      ) : (
        <div className="trabajadores-grid">
          {trabajadores.map(trabajador => (
            <div key={trabajador.id} className={`trabajador-card ${!trabajador.activo ? 'inactivo' : ''}`}>
              <div className="trabajador-header">
                <div>
                  <h3>{trabajador.nombre}</h3>
                  {trabajador.especialidad && (
                    <p className="especialidad">{trabajador.especialidad}</p>
                  )}
                </div>
                <div className="trabajador-status">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={trabajador.activo}
                      onChange={() => toggleActivo(trabajador)}
                    />
                    <span className="slider"></span>
                  </label>
                  <small>{trabajador.activo ? 'Activo' : 'Inactivo'}</small>
                </div>
              </div>

              <div className="trabajador-info">
                {trabajador.telefono && (
                  <p><strong>Teléfono:</strong> {trabajador.telefono}</p>
                )}
                {trabajador.email && (
                  <p><strong>Email:</strong> {trabajador.email}</p>
                )}
                {trabajador.costo_hora && (
                  <p><strong>Costo/hora:</strong> ${parseFloat(trabajador.costo_hora).toFixed(2)}</p>
                )}
              </div>

              <div className="trabajador-actions">
                <button
                  className="btn btn-secondary"
                  onClick={() => abrirModal(trabajador)}
                >
                  Editar
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => handleEliminar(trabajador.id)}
                >
                  Eliminar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modalAbierto && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>{trabajadorSeleccionado ? 'Editar Trabajador' : 'Nuevo Trabajador'}</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nombre Completo *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  placeholder="Nombre del trabajador"
                />
              </div>

              <div className="form-group">
                <label>Especialidad</label>
                <select
                  name="especialidad_id"
                  value={formData.especialidad_id}
                  onChange={handleChange}
                >
                  <option value="">Seleccionar especialidad</option>
                  {especialidades.map(esp => (
                    <option key={esp.id} value={esp.id}>
                      {esp.nombre}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Teléfono</label>
                  <input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    placeholder="+1234567890"
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="email@ejemplo.com"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Costo por Hora</label>
                <input
                  type="number"
                  name="costo_hora"
                  value={formData.costo_hora}
                  onChange={handleChange}
                  min="0"
                  step="0.01"
                  placeholder="0.00"
                />
              </div>

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary">
                  {trabajadorSeleccionado ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Trabajadores;
